import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import React, {useEffect, useState} from "react";
import IconBtn from "../../microComponents/elements/IconBtn";
import {useNavigate, useParams} from "react-router-dom";
import {IoReturnDownBackOutline} from "react-icons/io5";
import { FiPrinter } from "react-icons/fi";
import ProductsOrder from "./ProductsOrder";
import PalletListOrder from "./PalletListOrder";
import {IoMdAdd} from "react-icons/io";
import CreateEditInfoOrder from "./CreateEditInfoOrder";
import {Tabs} from "antd";
import {useSelector} from "react-redux";
import Pallet from "../../http_request/Model/pallet/Pallet";
import ConfirmSwitch from "../../microComponents/modals/ConfirmSwitch";
import {baseURL} from '../../http_request/url';
import Cookies from 'js-cookie';


const OrderEditCreate = ({create, show, edit}) => {
    const navigate = useNavigate();

    const addAgain = useSelector((state) => state.SettingRedux.addAgain);
    const [ , setLoading] = useState(false);
    const [data, setData] = useState();
    const [detail, setDetail] = useState();

    let {id} = useParams();

    const [reset, setReset] = useState(false);
    const [orderId, setOrderId] = useState(id);


    // const closeOrder = () => {
    //     Pallet.request({
    //         beforeSend: () => {
    //             setLoading(true)
    //         }, success: () => {
    //             toast.success('تغییرات با موفقیت انجام شد.')
    //          }, error: (error) => {
    //         }, final: () => {
    //             setLoading(false)
    //         },
    //     }).closeOrder(id);
    // }

    useEffect(() => {
        setOrderId(id)


        if (id) {
            Pallet.request({
                beforeSend: () => {
                    setLoading(true)
                }, success: ({result}) => {
                    setData(result[0])
                }, error: (error) => {
                }, final: () => {
                    setLoading(false)
                },
            }).addParams({page: 1, page_size: 10, OrderNumber: id}).getOrder();
            Pallet.request({
                beforeSend: () => {
                    setLoading(true)
                }, success: ({result}) => {
                    setDetail(result)
                }, error: (error) => {
                }, final: () => {
                    setLoading(false)
                },
            }).addParams({page: 1, page_size: 100000}).getOrderDetail(id);

        }


    }, [id])
    ;
    const items = [
        {
            label: `جزییات`,
            key: 1,
            children: <ProductsOrder id={orderId} data={detail} create={create} show={show} edit={edit} reset={reset}/>,
        }, (!!id && {
            label: `اموال`,
            key: 2,
            children: <PalletListOrder id={id}/>,
        })]
    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>حواله</Title>
                    <div className='flex gap-2 items-center'>
                        {
                            addAgain &&
                            <IconBtn color='greenIconBtn' TooltipText='اضافه کردن حواله جدید' onClick={() => {
                                setReset(prevState => !prevState)
                            }}>
                                <IoMdAdd size={20} color='white'/>
                            </IconBtn>
                        }
                        {/*<IconBtn color='blueIconBtn' TooltipText='بازگشت'>*/}
                        {/*    <Link to='/order'><IoReturnDownBackOutline size={20} color='white'/></Link>*/}
                        {/*</IconBtn>*/}
						
						<IconBtn color='greenIconBtn' TooltipText='پرینت' onClick={async () => {
							try {
								const token = Cookies.get('token')

								const response = await fetch(`${baseURL}Order/OrderPrint?orderNumber=${orderId}`, {
									method: 'GET',
									headers: {
										Authorization: `Bearer ${token}`
									}
								});

								if (!response.ok) {
									const errorText = await response.text();
									console.error('Server responded with:', response.status, errorText);
									throw new Error(`HTTP ${response.status}: ${errorText}`);
								}

								const blob = await response.blob();
								const url = window.URL.createObjectURL(blob);

								const link = document.createElement('a');
								link.href = url;
								link.setAttribute('download', `Order_${orderId}.xlsx`);
								document.body.appendChild(link);
								link.click();

								link.remove();
								window.URL.revokeObjectURL(url);
							} catch (error) {
								console.error('Download failed:', error);
								alert('خطا در دانلود فایل: ' + error.message);
							}
						}}>
							<FiPrinter size={20} color='white'/>
						</IconBtn>
						
                        <IconBtn color='blueIconBtn' TooltipText='بازگشت' onClick={() => {
                            navigate(-1);

                        }}>
                            <IoReturnDownBackOutline size={20} color='white'/>
                        </IconBtn>


                    </div>
                </div>
            </ComponentCard>
            <CreateEditInfoOrder data={data} setOrderId={setOrderId} reset={reset} orderId={orderId} create={create}
                                 show={show} edit={edit}/>
            {
                orderId &&

                <ComponentCard>
                    <Title>تعیین کالاهای حواله</Title>
                    <Tabs items={items} tabBarExtraContent={show &&


                        <ConfirmSwitch showButton id={id} checkedChildren='باز' unCheckedChildren='بسته' disabled={!data?.status && 'disabled'}
                                       title='بستن حواله'
                                       address={`Order/close/${id}`} defStatus={data?.status}
                                       des='در صورت بستن حواله امکان تغییرات در حواله وجود ندارد. آیا از بستن حواله اطمینان دارید؟'/>



                        }/>

                </ComponentCard>
            }


        </div>
    );
};


export default OrderEditCreate;
